import Accordian from "../../../components/WomenFacultyMeet/Accordian/Accordian";
import HeroSection from "../../../components/WomenFacultyMeet/herosection/herosection";
import "./committee.css"

export default function Committee({PNG}) {
    return (
        <div className="home">
            <HeroSection title="Committee" image={PNG.WomenFaculty} />
            <Accordian PNG={PNG}/>
        </div>
    )
} 